export const COLORS = {
  arkitektPlus: [
    {
      name: 'Arkitekt plus sand',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-sand.webp',
    },
    {
      name: 'Arkitekt plus granit',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-granit.webp',
    },
    {
      name: 'Arkitekt plus tall',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-tall.webp',
    },
    {
      name: 'Arkitekt plus frö',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-fro.webp',
    },
    {
      name: 'Arkitekt plus bark',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-bark.webp',
    },
    {
      name: 'Arkitekt plus hav',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-hav.webp',
    },
    {
      name: 'Arkitekt plus svartbetsad ek',
      src:
        'Marbodal/Price%20Configurator/Colors/arkitektplus-ek-svartbets.webp',
    },
    {
      name: 'Arkitekt plus ek',
      src: 'Marbodal/Price%20Configurator/Colors/arkitektplus-ek.webp',
    },
    {
      name: 'Arkitekt plus åska',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-aska.webp',
    },
    {
      name: 'Arkitekt plus moln',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-moln.webp',
    },
    {
      name: 'Arkitekt plus lin',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-lin.webp',
    },
    {
      name: 'Arkitekt plus frost',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-frost.webp',
    },
  ],
  signaturEkbacken: [
    {
      name: 'Signatur Ekbacken brunbets',
      src:
        'Marbodal/Price%20Configurator/Colors/signatur-ekbacken-brunbets.jpg',
    },
  ],
  fagero: [
    {
      name: 'Fagerö tall',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-tall.webp',
    },
    {
      name: 'Fagerö granit',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-granit.webp',
    },
    {
      name: 'Fagerö frö',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-fro.webp',
    },
    {
      name: 'Fagerö bark',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-bark.webp',
    },
    {
      name: 'Fagerö hav',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-hav.webp',
    },
    {
      name: 'Fagerö åska',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-aska.webp',
    },
    {
      name: 'Fagerö moln',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-moln.webp',
    },
    {
      name: 'Fagerö lin',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-lin.webp',
    },
    {
      name: 'Fagerö frost',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-frost.webp',
    },
    {
      name: 'Fagerö sand',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-sand.webp',
    },
  ],
  form: [
    {
      name: 'Form åska',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-aska.webp',
    },
    {
      name: 'Form granit',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-granit.webp',
    },
    {
      name: 'Form tall',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-tall.webp',
    },
    {
      name: 'Form frö',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-fro.webp',
    },
    {
      name: 'Form bark',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-bark.webp',
    },
    {
      name: 'Form hav',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-hav.webp',
    },
    {
      name: 'Form moln',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-moln.webp',
    },
    {
      name: 'Form lin',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-lin.webp',
    },
    {
      name: 'Form frost',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-frost.webp',
    },
    {
      name: 'Form sand',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-sand.webp',
    },
  ],
  lindo: [
    {
      name: 'Lindö frost',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-frost.webp',
    },
    {
      name: 'Lindö granit',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-granit.webp',
    },
    {
      name: 'Lindö tall',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-tall.webp',
    },
    {
      name: 'Lindö frö',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-fro.webp',
    },
    {
      name: 'Lindö bark',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-bark.webp',
    },
    {
      name: 'Lindö hav',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-hav.webp',
    },
    {
      name: 'Lindö åska',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-aska.webp',
    },
    {
      name: 'Lindö moln',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-moln.webp',
    },
    {
      name: 'Lindö lin',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-lin.webp',
    },
    {
      name: 'Lindö sand',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-sand.webp',
    },
    {
      name: 'Lindö ek',
      src: 'Marbodal/Price%20Configurator/Colors/arkitektplus-ek.webp',
    },
  ],
  viken: [
    {
      name: 'Viken åska',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-aska.webp',
    },
    {
      name: 'Viken frost',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-frost.webp',
    },
  ],
  ramsvik: [
    {
      name: 'Ramsvik svartbetsad ek',
      src:
        'Marbodal/Price%20Configurator/Colors/arkitektplus-ek-svartbets.webp',
    },
    {
      name: 'Ramsvik ek',
      src: 'Marbodal/Price%20Configurator/Colors/arkitektplus-ek.webp',
    },
  ],
  malevik: [
    {
      name: 'Malevik brun',
      src: 'Marbodal/Price%20Configurator/Colors/malevik-brun.webp',
    },
    {
      name: 'Malevik ljus',
      src: 'Marbodal/Price%20Configurator/Colors/malevik-ljus.webp',
    },
  ],
}

export const RANGES = {
  arkitektPlus: 'Marbodal/Price%20Configurator/Ranges/arkitektplus.jpg',
  signaturEkbacken:
    'Marbodal/Price%20Configurator/Ranges/signatur-ekbacken.jpg',
  fagero: 'Marbodal/Price%20Configurator/Ranges/fagero.jpg',
  form: 'Marbodal/Price%20Configurator/Ranges/form.jpg',
  lindo: 'Marbodal/Price%20Configurator/Ranges/lindo.jpg',
  viken: 'Marbodal/Price%20Configurator/Ranges/viken.jpg',
  ramsvik: 'Marbodal/Price%20Configurator/Ranges/ramsvik.jpg',
  malevik: 'Marbodal/Price%20Configurator/Ranges/malevik.jpg',
}

export const UNITS = {
  small: 'Marbodal/Price%20Configurator/Units/small.png',
  medium: 'Marbodal/Price%20Configurator/Units/medium.png',
  large: 'Marbodal/Price%20Configurator/Units/large.png',
}

export const WORKTOPS = {
  granite: 'Marbodal/Price%20Configurator/Worktops/granit.jpg',
  wood: 'Marbodal/Price%20Configurator/Worktops/ek.jpg',
  laminate: 'Marbodal/Price%20Configurator/Worktops/laminat.jpg',
  stainless: 'Marbodal/Price%20Configurator/Worktops/rostfri.jpg',
}
